module.exports = __webpack_public_path__ + "img/img_zhaopin.de207a89.jpg";